import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import {
  Flex,
  FONT_TYPES,
  fontFamilyMixin,
  mediaMixin,
  spaceMixin,
  Spacer,
  Tag,
  token,
  typographyMixin,
} from '@zillow/constellation';

import { TAG_APPEARANCES, TAG_SIZES } from '../../constants/TAG';

import Col from '../Col/Col';
import Row from '../Row/Row';

const StyledComponent = styled.div`
  padding: ${spaceMixin('sm')};
  background: ${token('colors.white')};
`;

const StyledText = styled.div`
  flex-grow: 2;

  /*
        manual work around to implement responsive typography
        responsive typography is in development
    */
  ${(props) => typographyMixin({ fontType: FONT_TYPES.h5, ...props })}

  ${mediaMixin(
    'md',
    css`
      ${(props) => typographyMixin({ fontType: FONT_TYPES.h4, ...props })};
    `,
  )}

    ${mediaMixin(
    'xl',
    css`
      ${(props) => typographyMixin({ fontType: FONT_TYPES.h3, ...props })};
    `,
  )}

    /* do override last so that parent spacing is not effected */
    ${mediaMixin(
    'xs',
    css`
      ${(props) => fontFamilyMixin({ fontFamily: 'serif', ...props })}
      line-height: 1em;
    `,
  )}
`;

const StyledHR = styled.hr`
  margin: 0;
  height: 1px;
  border-width: 0;
  background-color: #d1d1d5;
`;

const PropertyPageHeader = (props) => {
  const { children, title, statusConfig } = props;
  const { appearance, message, size } = statusConfig || {};

  return (
    <Row>
      <Col xs={12}>
        <StyledComponent className="PropertyPageHeader">
          <Spacer paddingBottom="sm">
            <Flex display="flex" flexDirection="row" alignItems="center">
              <StyledText>{title}</StyledText>

              {statusConfig && (
                <Tag appearance={appearance} size={size} data-test="status-tag">
                  {message}
                </Tag>
              )}
            </Flex>
          </Spacer>

          <Spacer paddingBottom="sm">
            <StyledHR />
          </Spacer>

          {children && <div className="PropertyPageHeader-Body">{children}</div>}
        </StyledComponent>
      </Col>
    </Row>
  );
};

PropertyPageHeader.propTypes = {
  children: PropTypes.node,
  statusConfig: PropTypes.shape({
    appearance: PropTypes.oneOf(Object.keys(TAG_APPEARANCES)).isRequired,
    message: PropTypes.string.isRequired,
    size: PropTypes.oneOf(Object.keys(TAG_SIZES)).isRequired,
  }),
  title: PropTypes.string.isRequired,
};

PropertyPageHeader.defaultProps = {
  children: null,
  statusConfig: null,
};

export default PropertyPageHeader;
